import { ErrorHandler, throttledLogError } from "seneca-common/utils/apiStates";

import memoryServiceErrorTranslator from "./errorTranslator";

const memoryServiceErrorHandler: ErrorHandler = (error, { errorAction }) => {
  errorAction(memoryServiceErrorTranslator(error));
  throttledLogError(error);
};

export default memoryServiceErrorHandler;
